import React, { FC } from 'react';

import { useTranslation } from '@crehana/i18n';

import getStaticUrl from 'Jsx/Utils/getStaticUrl';

const Guarantee: FC<{
  className?: string;
  itemType: string | null;
}> = ({ itemType, className }) => {
  const { t } = useTranslation();

  return (
    <div
      className={`sm:flex items-center sm:flex-shrink- text-base-main md:text-secondary-dark ${className}`}
    >
      {itemType !== 'degree' && (
        <img
          src={getStaticUrl('img/checkout/garantia.png')}
          width="84px"
          height="63px"
          alt="Garantía"
          className="hidden md:inline-block mb-16 mr-16 sm:mb-0"
        />
      )}
      {itemType === 'degree' ? (
        <p className="font-legals">
          <span className="mr-4 font-legals">{t('DEGREE_GUARANTEE')}</span>
          <a
            className="hover:underline"
            style={{
              color: 'inherit',
            }}
            target="_blank"
            rel="noopener noreferrer"
            href="https://ayuda.crehana.com/hc/es/articles/360053226054-MicroDegree-pol%C3%ADticas-de-reembolso"
          >
            {t('REFUND_POLICIES')}
          </a>
        </p>
      ) : (
        <p className="font-legals">
          <span> {t('GUARANTEE_INFO')}</span>
          <a
            className="ml-4 font-legal hover:underline"
            target="_blank"
            href="/legal/terminos-y-condiciones/"
          >
            {t('REFUND_POLICIES')}
          </a>
        </p>
      )}
    </div>
  );
};

export default Guarantee;
